// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_4OAEd","foot_link":"index_foot_link_A1cQg","list":"index_list_i-HLD","link":"index_link_7KRae","copyright":"index_copyright_qM1PT"};